module.exports = __webpack_public_path__ + "08d9a60e8fb26b1ea44e51faf4f45dc7.svg";